import { ROUTES, TITLES, PROD, STAGE, DEV } from 'consts';

export const CALLS_MENU = {
  key: ROUTES.CALLS.ROOT,
  label: TITLES[ROUTES.CALLS.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.CALLS.APARTMENTS,
      label: TITLES[ROUTES.CALLS.APARTMENTS],
      environment: [DEV, STAGE, PROD],
      children: [
        {
          key: ROUTES.CALLS.APARTMENTS_ALLOCATED,
          label: TITLES[ROUTES.CALLS.APARTMENTS_ALLOCATED],
          environment: [DEV, STAGE, PROD],
        },
        {
          key: ROUTES.CALLS.APARTMENTS_UNALLOCATED,
          label: TITLES[ROUTES.CALLS.APARTMENTS_UNALLOCATED],
          environment: [DEV, STAGE, PROD],
        },
      ],
    },
    {
      key: ROUTES.CALLS.ENG_NETWORKS,
      label: TITLES[ROUTES.CALLS.ENG_NETWORKS],
      environment: [DEV, STAGE, PROD],
      children: [
        {
          key: ROUTES.CALLS.ENG_NETWORKS_ALLOCATED,
          label: TITLES[ROUTES.CALLS.ENG_NETWORKS_ALLOCATED],
          environment: [DEV, STAGE, PROD],
        },
        {
          key: ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED,
          label: TITLES[ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED],
          environment: [DEV, STAGE, PROD],
        },
        {
          key: ROUTES.CALLS.ENG_NETWORKS_MY_CALLS,
          label: TITLES[ROUTES.CALLS.ENG_NETWORKS_MY_CALLS],
          environment: [DEV, STAGE, PROD],
        },
      ],
    },
  ],
};
